import React from "react";

import logo from "../images/EYLogo.png";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarText,
} from "reactstrap";
import { NavLink as RRNavLink } from "react-router-dom";
import { LoggedUserContext } from "../LoggedUserContext";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getToken, logout, acquireToken } from "../adalConfig";
import { Button } from "@material-ui/core";

const MySwal = withReactContent(Swal);

export default class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      hiddenMenus: [],
    };
  }

  componentDidMount() {
    this.setState({
      hiddenMenus: {
        Home: true,
        Reports: true,
        Historic: true,
        NewCampaign: true,
        EmailAccounts: true,
        DoNotDisturb: true,
        Users: true,
      },
    });

    axios
      .get(`${process.env.REACT_APP_API_URL}/ModuleAPI/GetModulePerUserId`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      })
      .then((res) => {
        if (res.data.code === 0) {
          res.data.items.forEach((element) => {
            switch (element.moduleName) {
              case "Home":
                this.setState((prevState) => ({
                  hiddenMenus: {
                    ...prevState.hiddenMenus,
                    Home: false,
                  },
                }));
                break;
              case "Report":
                this.setState((prevState) => ({
                  hiddenMenus: {
                    ...prevState.hiddenMenus,
                    Reports: false,
                  },
                }));
                break;
              case "Historic":
                  this.setState((prevState) => ({
                    hiddenMenus: {
                      ...prevState.hiddenMenus,
                      Historic: false,
                    },
                  }));
                  break;
              case "Campaing":
                this.setState((prevState) => ({
                  hiddenMenus: {
                    ...prevState.hiddenMenus,
                    NewCampaign: false,
                  },
                }));
                break;
              case "Email Account":
                this.setState((prevState) => ({
                  hiddenMenus: {
                    ...prevState.hiddenMenus,
                    EmailAccounts: false,
                  },
                }));
                break;
              case "Do Not Disturb":
                this.setState((prevState) => ({
                  hiddenMenus: {
                    ...prevState.hiddenMenus,
                    DoNotDisturb: false,
                  },
                }));
                break;
              case "User":
                this.setState((prevState) => ({
                  hiddenMenus: {
                    ...prevState.hiddenMenus,
                    Users: false,
                  },
                }));
                break;

              default:
                MySwal.fire({
                  text:
                    "It seems that the current user has permissions for a module not contemplated when creating the app. Please contact the administrator if you receive this message",
                  title: "Error",
                  icon: "error",
                });
            }
          });
        } else {
          MySwal.fire({
            icon: "error",
            title:
              "An error has occurred while retrieving the user permissions",
            text: res.data.description,
            confirmButtonColor: "#FFE600",
            confirmButtonText: "<div style='color: black'>OK</div>",
          }).then(() => {
            window.location.reload();
          });
        }
      })
      .catch((error) => {
        if (error.toString().includes("status code 403")) {
          window.location.href = "/NoAuth";
        } else {
          MySwal.fire({
            icon: "error",
            title:
              "An error has occurred while retrieving the user permissions",
            text: error,
            confirmButtonColor: "#FFE600",
            confirmButtonText: "<div style='color: black'>OK</div>",
          }).then(() => {
            window.location.reload();
          });
        }
      });
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <Navbar dark expand="lg">
        <NavbarBrand href="/">
          <img src={logo} height="32" className="App-logo" alt="logo" />
        </NavbarBrand>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="lg" navbar>
            <NavItem className="navItem">
              <NavLink
                tag={RRNavLink}
                className="nav-link"
                to="/"
                activeClassName="active"
                exact
                path="/"
                hidden={this.state.hiddenMenus.Home}
              >
                Home
              </NavLink>
            </NavItem>
            <NavItem className="navItem">
              <NavLink
                tag={RRNavLink}
                className="nav-link"
                to="/Reports"
                activeClassName="active"
                hidden={this.state.hiddenMenus.Reports}
              >
                Reports by Email
              </NavLink>
            </NavItem>
            <NavItem className="navItem">
              <NavLink
                tag={RRNavLink}
                className="nav-link"
                to="/Historic"
                activeClassName="active"
                hidden={this.state.hiddenMenus.Historic}
              >
                Historic Report
              </NavLink>
            </NavItem>
            <NavItem className="navItem">
              <NavLink
                tag={RRNavLink}
                className="nav-link"
                to="/NewCampaign"
                activeClassName="active"
                hidden={this.state.hiddenMenus.NewCampaign}
              >
                New Campaign
              </NavLink>
            </NavItem>
            <NavItem className="navItem">
              <NavLink
                tag={RRNavLink}
                className="nav-link"
                to="/EmailAccounts"
                activeClassName="active"
                hidden={this.state.hiddenMenus.EmailAccounts}
              >
                Email Accounts
              </NavLink>
            </NavItem>
            <NavItem className="navItem">
              <NavLink
                tag={RRNavLink}
                className="nav-link"
                to="/DoNotDisturb"
                activeClassName="active"
                hidden={this.state.hiddenMenus.DoNotDisturb}
              >
                Do Not Disturb
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag={RRNavLink}
                className="nav-link"
                to="/Users"
                activeClassName="active"
                hidden={this.state.hiddenMenus.Users}
              >
                Users
              </NavLink>
            </NavItem>
          </Nav>
          <NavbarText style={{ right: "6rem", position: "absolute" }}>
            Welcome {this.context.userFirstName} {this.context.userLastName}
          </NavbarText>
          <Button
            style={{ right: "1rem", position: "absolute" }}
            onClick={() => {
              this.BlacklistTokenAndLogout();
            }}
          >
            Logout
          </Button>
        </Collapse>
      </Navbar>
    );
  }

  BlacklistTokenAndLogout() {
    acquireToken().then((token) => {
      const url = `${process.env.REACT_APP_API_URL}/AzureAdIdentityAPI/BlacklistToken`;
      axios.post(
        url,
        {},
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      ).then((res) => {
        logout();
      });
    });
  }
  
}

NavBar.contextType = LoggedUserContext;
